<template>
  <div>
    <div class="title_h1">作業報告書提出</div>
    <vab-collapse-info>
      <template slot="title">基本情報</template>
      <template slot="file">
        <info-link ref="infolink" @onbus="sendData"></info-link>
      </template>
      <template slot="row">
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">建物</vab-col>
          <vab-col :span="20" class="word_box bdr0">
            {{
              getFieldValue('buildingCdMbuildgpModel.blgsnmkj', currentBascInfo)
            }}
          </vab-col>
          <vab-col :span="4" class="title_box">作業名</vab-col>
          <vab-col :span="20" class="word_box bdr0">
            {{ getFieldValue('workName', currentBascInfo) }}
          </vab-col>
          <vab-col :span="4" class="title_box">発注No連番</vab-col>
          <vab-col :span="8" class="word_box">
            {{
              getFieldValue(
                'purchaseOrderDetailIdModel.acceptOrderNoSeq',
                currentBascInfo
              )
            }}
          </vab-col>
          <!-- <vab-col :span="4" class="title_box">発注先</vab-col>
          <vab-col :span="8" class="word_box bdr0">
            <div class="flex_space">
              <div>
                {{ getFieldValue('supplierCdModel.bcnfrkj', currentBascInfo) }}
              </div>
              <div class="sub_title">
                （協力会社CD：{{
                  getFieldValue('supplierCd', currentBascInfo)
                }}）
              </div>
            </div>
          </vab-col> -->
          <vab-col :span="4" class="title_box">報告書No</vab-col>
          <vab-col :span="8" class="word_box bdr0">
            {{ getFieldValue('workNo', currentBascInfo) }}
          </vab-col>
          <vab-col :span="4" class="title_box">作業予定期間</vab-col>
          <vab-col :span="8" class="word_box">
            <template
              v-if="
                getFieldValue('planWorkStartDate', currentBascInfo) &&
                getFieldValue('planWorkEndDate', currentBascInfo)
              "
            >
              {{ getFieldValue('planWorkStartDate', currentBascInfo) }}
              〜
              {{ getFieldValue('planWorkEndDate', currentBascInfo) }}
            </template>
          </vab-col>
          <vab-col :span="4" class="title_box">作業実施期間</vab-col>
          <vab-col :span="8" class="word_box">
            <template
              v-if="
                getFieldValue('resultWorkStartDate', currentBascInfo) &&
                getFieldValue('resultWorkEndDate', currentBascInfo)
              "
            >
              {{ getFieldValue('resultWorkStartDate', currentBascInfo) }}
              〜
              {{ getFieldValue('resultWorkEndDate', currentBascInfo) }}
            </template>
          </vab-col>
        </vab-row>
      </template>
    </vab-collapse-info>
    <vab-collapse-info class="mt16">
      <template slot="title">前回報告情報</template>
      <template slot="row">
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">前回報告書No</vab-col>
          <vab-col
            :span="20"
            :class="read ? 'word_box bdr0' : 'word_box word_link bdr0'"
          >
            <span @click="goPreReport">
              {{ getFieldValue('reportNo', preBasicInfo) }}
            </span>
          </vab-col>
          <vab-col :span="4" class="title_box">前回報告日</vab-col>
          <vab-col :span="8" class="word_box">
            {{ getFieldValue('reportIdModel.createDate', preBasicInfo) }}
          </vab-col>
          <vab-col :span="4" class="title_box">前回実施期間</vab-col>
          <vab-col :span="8" class="word_box">
            <template
              v-if="
                getFieldValue('resultWorkStartDate', preBasicInfo) &&
                getFieldValue('resultWorkEndDate', preBasicInfo)
              "
            >
              {{ getFieldValue('resultWorkStartDate', preBasicInfo) }}
              〜
              {{ getFieldValue('resultWorkEndDate', preBasicInfo) }}
            </template>
          </vab-col>
        </vab-row>
      </template>
    </vab-collapse-info>
  </div>
</template>

<script>
  export default {
    name: 'ReportBasic',
    data() {
      return {
        currentBascInfo: null,
        preBasicInfo: null,
        read: false,
      }
    },
    mounted() {},
    methods: {
      setBaicInfo(curInfo, preInfo, only) {
        this.currentBascInfo = curInfo
        this.preBasicInfo = preInfo
        this.read = only
      },
      setOpenLink(progessTargetClass) {
        if (this.$refs.infolink) {
          this.$refs.infolink.setReportData({
            reportShow: true,
            progessTargetClass: progessTargetClass,
          })
        }
      },
      sendData() {
        this.$emit('goEntryManagementPage')
      },
      // 前回報告情報
      async goPreReport() {
        if (this.read) return
        this.$router.push({
          name: 'PWR02G06_RO',
          query: {
            workNo: this.preBasicInfo?.reportNo,
            itemDetailCd: this.$route.query?.itemDetailCd,
            reportId: this.preBasicInfo?.reportIdModel?.reportId,
            workSpecCd: this.preBasicInfo?.workSpecCd,
          },
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import '@/vab/styles/reportRc.scss';
</style>
